import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/of';
import { delay, tap, take } from 'rxjs/operators';
import { switchMap, first } from "rxjs/operators";


//Firebase
import { AngularFirestore, AngularFirestoreDocument } from "angularfire2/firestore";



export class FirestoreService{

  // Firestore Document
  private docRef: AngularFirestoreDocument;

  // Reference document
  public path: string;

  // Object to persist
  public doc: any;

  constructor(public afs: AngularFirestore, path: string){
    this.path = path;
  }

  // Loads initial form data from Firestore
  preloadData() {
    this.docRef = this.getDocRef(this.path);    
    this.docRef
      .valueChanges()
      .pipe(
        tap(doc => {
          if (doc) {
            this.doc = doc;
           this.onLoadData();
          }
        }),
        take(1)
      )
      .subscribe();
  }

  preloadDataWithCollection(collection: string) {
    this.docRef = this.getDocRef(this.path);    
    this.docRef
      .valueChanges()
      .pipe(
        tap(doc => {
          if (doc) {
            this.doc = doc;
            this.docRef.collection(collection).valueChanges()
                                              .pipe(
                                                tap(data => {
                                                  if (data) {
                                                    this.doc[collection] = data;
                                                    this.onLoadData();                                                    
                                                  }
                                                }),
                                                take(1)
                                              )
                                              .subscribe();

          }
        }),
        take(1)
      )
      .subscribe();
  }
  

  onLoadData(){
    
  }

  // Determines if path is a collection or document
  getDocRef(path: string): any {
    if(this.doc === undefined){
      return this.afs.doc(path);
    }

    if (path.split('/').length % 2) {
      
      this.doc.uid = this.afs.createId();
      return this.afs.doc(`${path}/${this.doc.uid}`);
    } else {
      return this.afs.doc(path);
    }
  }

  // Writes changes to Firestore
  async saveDoc() {
    try {
      await this.docRef.set(Object.assign({}, this.doc), { merge: true });
    } catch (err) {
      console.error(err);
    }
  }

  // Writes changes to Firestore
  async saveDocWithCollection(collection: string) {
    let array = this.doc[collection];
    //this.doc[collection]=null;
    try {
      await this.docRef.set(Object.assign({}, this.doc), { merge: true });
      for(let item of array){
        await this.afs.collection(collection).doc(item.uid).set(Object.assign({}, item), { merge: true });
      }
    } catch (err) {
      console.error(err);
    }
  }

  getDocs(){
    try{
      return this.afs.collection(this.path, ref => 
        ref.where("delete", "==", false)
      );
    }catch(error){
      return this.afs.collection(this.path);
    }    
  }

  getDocsOrderBy(field: string, order: any){
    return this.afs.collection(this.path, ref => 
      ref.orderBy(field, order).where("delete", "==", false)
    );
  }

  async deleteDoc(uid: string){
    try {
      return await this.afs.doc(`${this.path}/${uid}`).set({delete: true}, { merge: true });
      //return await this.afs.doc(`${uid}`).set({delete: true}, { merge: true });
    } catch (error) {
      console.error("error deleteDoc", error);
      throw error;
    }
  }

  async activateDoc(doc: any){
    console.log("doc", doc);
    try {
      return await this.afs.doc(`${this.path}/${doc.uid}`).set({active: !doc.active}, { merge: true });
    } catch (error) {
      console.error("error activateDoc", error);
      throw error;
    }
  }

  async getNumberRows(){
    let count = 0;
    await this.afs.collection(this.path).ref.get().then(function(querySnapshot) {      
      count = querySnapshot.size; 
      return count;
    }).catch(error => {return 0} );    
  }

}
